var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "800px" },
      model: {
        value: _vm.visible,
        callback: function($$v) {
          _vm.visible = $$v
        },
        expression: "visible"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "content" },
        [
          _c(
            "v-card-title",
            [
              _c(
                "span",
                { staticClass: "headline text-uppercase font-weight-medium" },
                [_vm._v("\n        Criar Documento\n      ")]
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "accent",
                    rounded: "",
                    icon: "",
                    outlined: ""
                  },
                  on: {
                    click: function($event) {
                      return _vm.closeDialog()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { column: "" } },
            [
              _c("v-select", {
                attrs: {
                  required: "",
                  autofocus: "",
                  label: "Selecione o tipo de documento",
                  "prepend-inner-icon": "mdi-file-document",
                  items: _vm.ocrDocumentType
                },
                on: { input: _vm.setDocumentType }
              }),
              _vm._v(" "),
              !_vm.isSelfie
                ? _c(
                    "div",
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "numeric",
                            expression: "'numeric'"
                          }
                        ],
                        attrs: {
                          name: "rg",
                          label: "Numero registro",
                          "error-messages": _vm.errors.first("rg"),
                          error: _vm.errors.has("rg")
                        },
                        on: {
                          input: function($event) {
                            return _vm.setValueToContent($event, "rg")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|alpha_spaces",
                            expression: "'required|alpha_spaces'"
                          }
                        ],
                        attrs: {
                          name: "rgIssuingAuthority",
                          label: "Orgao emissor",
                          "error-messages": _vm.errors.first(
                            "rgIssuingAuthority"
                          ),
                          error: _vm.errors.has("rgIssuingAuthority")
                        },
                        on: {
                          input: function($event) {
                            return _vm.setValueToContent(
                              $event,
                              "rgIssuingAuthority"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|alpha_spaces",
                            expression: "'required|alpha_spaces'"
                          }
                        ],
                        attrs: {
                          name: "rgIssueState",
                          label: "Estado emissor",
                          "error-messages": _vm.errors.first("rgIssueState"),
                          error: _vm.errors.has("rgIssueState")
                        },
                        on: {
                          input: function($event) {
                            return _vm.setValueToContent($event, "rgIssueState")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: "##/##/####",
                            expression: "'##/##/####'"
                          }
                        ],
                        attrs: {
                          "return-masked-value": "",
                          name: "issueDate",
                          label: "Data de expedicao",
                          "error-messages": _vm.errors.first("issueDate"),
                          error: _vm.errors.has("rgIssuingDate")
                        },
                        on: {
                          input: function($event) {
                            return _vm.setValueToContent($event, "issueDate")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: "###.###.###-##",
                            expression: "'###.###.###-##'"
                          }
                        ],
                        attrs: {
                          "return-masked-value": "",
                          name: "cpf",
                          label: "CPF",
                          "error-messages": _vm.errors.first("cpf"),
                          error: _vm.errors.has("cpf")
                        },
                        on: {
                          input: function($event) {
                            return _vm.setValueToContent($event, "cpf")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|alpha_spaces",
                            expression: "'required|alpha_spaces'"
                          }
                        ],
                        attrs: {
                          name: "name",
                          label: "Nome",
                          "error-messages": _vm.errors.first("name"),
                          error: _vm.errors.has("name")
                        },
                        on: {
                          input: function($event) {
                            return _vm.setValueToContent($event, "name")
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                [
                  _vm.isSelfie
                    ? _c("v-file-input", {
                        attrs: {
                          label: "Inserir Selfie",
                          filled: "",
                          "prepend-icon": "mdi-camera"
                        },
                        on: {
                          change: function($event) {
                            return _vm.submitUploadDocumentPicture(
                              $event,
                              "selfie"
                            )
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isSelfie
                    ? _c("v-file-input", {
                        attrs: {
                          label: "Inserir frente do documento",
                          filled: "",
                          "prepend-icon": "mdi-camera"
                        },
                        on: {
                          change: function($event) {
                            return _vm.submitUploadDocumentPicture(
                              $event,
                              "front"
                            )
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isSelfie
                    ? _c("v-file-input", {
                        attrs: {
                          label: "Inserir verso do documento",
                          filled: "",
                          dense: "",
                          "prepend-icon": "mdi-camera"
                        },
                        on: {
                          change: function($event) {
                            return _vm.submitUploadDocumentPicture(
                              $event,
                              "back"
                            )
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        small: "",
                        disabled: _vm.UploadDocLoader,
                        loading: _vm.loader,
                        djfdhfksd: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.dispatchDocument()
                        }
                      }
                    },
                    [_c("span", [_vm._v("Criar documento")])]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54daa248", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54daa248","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Documents/NewDocument/Index.vue
// module id = null
// module chunks = 